import classNames from 'classnames/bind';
import styles from './EditProject.module.scss';
import ProjectForm from '../Form/ProjectForm';
import { getData, postData } from '~/helper/apiService';
import { useContext, useEffect, useRef, useState } from 'react';
import { ToastContext } from '../Context/ToastProvider';

const cx = classNames.bind(styles);

function EditProject({id}) {
  const fileInputRef = useRef(null);
  const [key, setKey] = useState('');
  const [poroject, setProject] = useState({});
  const { addToast } = useContext(ToastContext);

  const loadProject = async () => {
    const res = await getData(`/projects/read/${id}`);
    if (res) setProject(res[0]);
  };

  useEffect(() => {
    loadProject();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append('id', id);

    const res = await postData('/projects/update', formData);
    if (res.status === 'success') {
      loadProject();
      setKey((prev) => prev + 1);
    } else {
      addToast(res);
    }
  };

  return (
    <div className={cx('wrapper')}>
      <ProjectForm
        key={key}
        titleBtn="Edit project"
        data={poroject}
        handleSubmit={handleSubmit}
        fileInputRef={fileInputRef}
      />
    </div>
  );
}

export default EditProject;
